import { Collapse, IconButton, List } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ExpandIcon from '@mui/icons-material/ExpandMore';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import MenuItem from './MenuItem';

const useStyles = makeStyles()((theme) => ({
  link: {
    color: theme.palette.common.white,
    transition: theme.transitions.create(['color', 'border-right'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      borderRight: `2px solid ${theme.palette.primary.dark}`,
    },
  },
  listItem: {
    borderRight: `2px solid ${theme.palette.divider}`,
  },
  icon: {
    fontSize: 'inherit',
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.short,
    }),
  },
  iconButton: {
    height: 30,
    width: 30,
  },
  expandIconButton: {
    position: 'absolute',
    right: 0,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    height: '100%',
    borderRadius: 0,
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  rotatedIcon: {
    transform: 'rotate(180deg)',
  },
}));

interface ExpandableMenuItemProps {
  pathname: string;
  path: string;
  label: string;
  submenu: React.ReactNode;
}

export default function ExpandableMenuItem({
  pathname,
  path,
  label,
  submenu,
}: ExpandableMenuItemProps) {
  const { classes } = useStyles();
  const [state, setState] = React.useState({
    expanded: pathname.includes(path),
  });

  return (
    <Fragment key={path}>
      <MenuItem pathname={pathname} to={path} label={label}>
        <IconButton
          onClick={(event) => {
            event.preventDefault();
            setState({ expanded: !state.expanded });
          }}
          className={classNames(classes.iconButton, classes.expandIconButton)}
          size="large"
        >
          <ExpandIcon
            className={classNames(classes.icon, {
              [classes.rotatedIcon]: state.expanded,
            })}
          />
        </IconButton>
      </MenuItem>
      <Collapse in={state.expanded} timeout="auto" unmountOnExit>
        <List component="nav" disablePadding dense>
          {submenu}
        </List>
      </Collapse>
    </Fragment>
  );
}
